angular.module('signalflowV2ApiUtils.v2Detector', []).service('convertV1ToV2Detector', [
    '$window',
    function ($window) {
        return $window.signalviewV2ApiUtils.detector.convertV1ToV2;
    },
]);
